import {
    NEW_PASSWORD_REQUIRED,
    NOT_AUTHORIZED_EXCEPTION,
    INVALID_USER,
    NEW_PASSWORDS_MUST_MATCH,
    CODE_MISMATCH_EXCEPTION,
    INVALID_PASSWORD_EXCEPTION,
    LIMIT_EXCEEDED_EXCEPTION,
    INVALID_PARAMETER_EXCEPTION,
} from './cognito';

export const POI_STATUS_TYPE = {
    DIRTY: 'DIRTY',
    SAVING: 'SAVING',
    ERROR: 'ERROR',
};

export const LOGIN_ISSUES = {
    NEW_PASSWORD_REQUIRED,
    NOT_AUTHORIZED_EXCEPTION,
    INVALID_USER,
    NEW_PASSWORDS_MUST_MATCH,
    CODE_MISMATCH_EXCEPTION,
    INVALID_PASSWORD_EXCEPTION,
    LIMIT_EXCEEDED_EXCEPTION,
    INVALID_PARAMETER_EXCEPTION,
};

export const BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE = {
    NONE: null,
    DELETE: 'DELETE',
    REPLACE: 'REPLACE',
    STATUS_CHANGE: 'STATUS_CHANGE',
    CATEGORY_CHANGE: 'CATEGORY_CHANGE',
    ICON_CHANGE: 'ICON_CHANGE',
    SECURITY_CHANGE: 'SECURITY_CHANGE',
    ARRAY_ADD: 'ARRAY_ADD',
    ARRAY_REMOVE: 'ARRAY_REMOVE',
    KEY_VALUE_SET: 'KEY_VALUE_SET',
    KEY_VALUE_REMOVE: 'KEY_VALUE_REMOVE',
};

export const BANNER_COLORS = {
    RED: 'red',
    GREEN: 'green',
    BLUE: 'blue',
};

export const BANNER_ICONS = {
    FAIL: 'icon-warning',
    RUNNING: 'icon-fluidloader',
    SUCCESS: 'icon-circle-check',
};

export const BANNER_SUCCESS = {
    CHANGED_PASSWORD: 'CHANGED_PASSWORD',
    PROFILE_UPDATED: 'PROFILE_UPDATED',
    EMAIL_VERIFIED: 'EMAIL_VERIFIED',
};

// for lower permissions exporting poi to csv
export const POI_SECONDARY_CSV_FIELDS = [
    {
        label: '#Id',
        value: 'id',
    },
    {
        label: 'Name',
        value: 'name',
    },
    {
        label: 'Category',
        value: 'category',
    },
    {
        label: 'Description',
        value: 'description',
    },
    {
        label: 'Phone',
        value: 'phone',
    },
    {
        label: 'Url',
        value: 'url',
    },
    {
        label: 'Terminal',
        value: 'terminal',
    },
    {
        label: 'Nearby Location',
        value: 'gate',
    },
    {
        label: 'Level',
        value: 'floor',
    },
    {
        label: 'Hours',
        value: 'rawHours',
    },
    {
        label: 'Displayed Tags',
        value: 'displayTags',
    },
    {
        label: 'Hidden Tags',
        value: 'tags',
    },
];

// for exporting to csv
const additionalFields = [
    {
        label: 'Security',
        value: 'security',
    },
    {
        label: 'Lat',
        value: 'lat',
    },
    {
        label: 'Long',
        value: 'lng',
    },
];
export const POI_CSV_FIELDS = [...POI_SECONDARY_CSV_FIELDS, ...additionalFields];

export const MENUS = {
    VENUES: 'venues',
    WAYFINDING: 'wayfinding',
    COMMAND_LINE_TOOLS: 'Command Line Tools',
    LAYERS: 'layers',
    HELP: 'help',
    IMPORT_EXPORT: 'Import/Export',
    MOD_WIZARD: 'MapsOnDisplay Wizard',
};

export const ERRORCODES = {
    UNKNOWN_ERROR: '100001',
    UPDATE_ENTITY_ERROR: '100002',
    VENUE_NOT_FOUND: '100003',
};
